import { PRODUCT_CONFIG } from './constants/product';

import { stringToBase64 } from './stringConversion';

export const getSSORedirectUrl = (rdr = '/') => `${process.env.REACT_APP_SSO_BASE_URL}?product=${PRODUCT_CONFIG.NAME}&return_path=${stringToBase64(rdr)}`;

export const getSSOLogoutRedirectUrl = (rdr = '/') => `${process.env.REACT_APP_SSO_BASE_URL}/logout?product=${PRODUCT_CONFIG.NAME}&return_path=${stringToBase64(rdr)}`;

export const redirectAfterLogout = () => {
  window.location.href = getSSORedirectUrl();
};

const promptForSID = (() => {
  let isPrompted = false;
  return () => {
    if (!isPrompted) {
      isPrompted = true;
      // eslint-disable-next-line no-alert
      const sid = window.prompt('Paste sid here', '');
      if (sid) {
        const date = new Date();
        date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 days expiry
        document.cookie = `sid=${sid};expires=${date.toUTCString()}; path='/'`;
        if(window.location.pathname!=='/'){
          window.location.replace('/');
        }
      }
    }
  };
})();

export const redirectToSSOWithParams = (rdr = '/') => {
    if (process.env.NODE_ENV === 'development') {
      promptForSID();
    } else {
      const searchStr = decodeURIComponent(window.location.search);
      window.location.replace(getSSORedirectUrl(`${rdr}${searchStr}`));
    }
};
